import { getMapBalance } from "./balance.js";

export const ENEMY_BASE = {
	scout: { name: "Scout", hp: 30, speed: 2.2, reward: 3, color: "#9df27f", size: 6 },
	soldier: { name: "Soldier", hp: 80, speed: 1.4, reward: 7, color: "#ff8f8f", size: 8 },
	tank: { name: "Tank", hp: 250, speed: 1.1, reward: 18, color: "#c8d2dc", size: 11 },
	sprinter: { name: "Sprinter", hp: 50, speed: 3.3, reward: 8, color: "#fff071", size: 6 },
	healer: { name: "Healer", hp: 100, speed: 1.2, reward: 14, color: "#a7f2a7", size: 8, heals: true },
	reinforced: { name: "Reinforced", hp: 250, speed: 1.0, reward: 22, color: "#aab5c0", size: 12, reinforced: true },
	fireman: { name: "Fireman", hp: 150, speed: 1.7, reward: 16, color: "#ff7b45", size: 8, fireman: true },
	frostbite: { name: "Frostbite", hp: 190, speed: 1.6, reward: 18, color: "#73d8ff", size: 9, frostImmune: true },
	boss: { name: "Boss", hp: 800, speed: 0.9, reward: 75, color: "#ff63b8", size: 14 },
};

export const ENEMY_ORDER = ["scout", "soldier", "tank", "sprinter", "healer", "reinforced", "fireman", "frostbite", "boss"];

export const ENEMY_FIRST_APPEARANCE = {
	scout: 1,
	soldier: 2,
	tank: 5,
	sprinter: 6,
	healer: 8,
	reinforced: 10,
	fireman: 6,
	frostbite: 8,
	boss: 10,
};

export const ENEMY_ABILITIES = {
	scout: ["Fast basic unit"],
	soldier: ["Balanced frontline unit"],
	tank: ["High HP", "Slow movement"],
	sprinter: ["Very high speed", "Low durability"],
	healer: ["Heals nearby enemies"],
	reinforced: ["Only damaged by Sniper Lv.2+"],
	fireman: ["Only damaged by Frost or while frozen"],
	frostbite: ["Immune to Frost slow"],
	boss: ["Extreme HP", "High payout"],
};

export const getEnemyDef = (type, context = 0) => {
	const base = ENEMY_BASE[type];
	const mapIdx = typeof context === "number" ? context : context?.mapIdx || 0;
	const runMode = typeof context === "object" ? context?.runMode || "campaign" : "campaign";
	const waveNumber = typeof context === "object" ? context?.waveNumber || 0 : 0;
	const survivalTier = Math.floor(Math.max(0, waveNumber - 1) / 5);
	const mapBalance = getMapBalance({
		mapIdx,
		mapDef: typeof context === "object" ? context?.mapDef : null,
	});

	let hpMult = mapBalance.enemyHp;
	let spdMult = mapBalance.enemySpeed;
	let rewardMult = mapBalance.enemyReward;

	if (runMode === "survival") {
		hpMult *= 1 + survivalTier * 0.145;
		spdMult *= 1 + Math.min(0.32, survivalTier * 0.022);
		rewardMult *= 1 + survivalTier * 0.045;
	}

	return {
		...base,
		hp: Math.round(base.hp * hpMult),
		speed: Number((base.speed * spdMult).toFixed(2)),
		reward: Math.max(1, Math.round(base.reward * rewardMult)),
	};
};
